export default "__VITE_ASSET__00e904a4__"